




























import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useRoute
} from '@nuxtjs/composition-api';

import VaimoButton from '~/diptyqueTheme/components/atoms/VaimoButton.vue';
import { useSocialLogin } from '~/diptyqueTheme/composable/useSocialLogin';

export default defineComponent({
  name: 'VaimoSocialLogin',
  components: {
    VaimoButton
  },
  setup() {
    const route = useRoute();
    const routePath = computed(() => route.value.path);
    const {
      loginWithFacebook,
      initGoogleLogin,
      initFacebookLogin,
      renderGoogleButton,
      isFbSocialLoginEnabled,
      isGoogleSocialLoginEnabled,
      checkIsGoogleLibraryLoaded
    } = useSocialLogin();
    const isThankYouPage = computed(() =>
      routePath.value.includes('checkout/thank-you')
    );
    const googleSocialLoginButton = ref<HTMLElement>(null);
    const isGoogleButtonVisible = ref<boolean>(false);

    const handleGoogleButtonRender = () => {
      const text = isThankYouPage.value ? 'signin_with' : 'continue_with';
      renderGoogleButton(googleSocialLoginButton.value, text);
    };

    const setupGoogleLogin = () => {
      if (!isGoogleSocialLoginEnabled.value) return;

      if (checkIsGoogleLibraryLoaded()) {
        isGoogleButtonVisible.value = true;
        handleGoogleButtonRender();
        return;
      }

      window.onGoogleLibraryLoad = () => {
        initGoogleLogin();
        handleGoogleButtonRender();

        requestAnimationFrame(() => {
          if (googleSocialLoginButton.value?.querySelector('iframe')) {
            isGoogleButtonVisible.value = true;
          }
        });
      };
    };

    const setupFacebookLogin = () => {
      if (isFbSocialLoginEnabled.value) {
        window.fbAsyncInit = () => initFacebookLogin();
      }
    };

    onMounted(() => {
      setupGoogleLogin();
      setupFacebookLogin();
    });

    return {
      isThankYouPage,
      loginWithFacebook,
      googleSocialLoginButton,
      isGoogleButtonVisible,
      isFbSocialLoginEnabled,
      isGoogleSocialLoginEnabled
    };
  },
  head() {
    return {
      meta: [{ name: 'referrer', content: 'strict-origin-when-cross-origin' }],
      script: [
        {
          src: 'https://accounts.google.com/gsi/client',
          async: true,
          defer: true
        },
        {
          src: 'https://apis.google.com/js/api.js',
          async: true,
          defer: true
        },
        {
          src: 'https://connect.facebook.net/en_US/sdk.js',
          async: true
        }
      ]
    };
  }
});
